/**
 * * Модель запроса на обновлене связи очереди с задачей
 */
export default class AddQueueRelationRequest  {
	/**
	 * * Номер задачи
	 */
	TaskId!: number;
	/**
	 * * Номер очереди задач
	 */
	QueueTaskId!: string;
	constructor(obj?: Partial<AddQueueRelationRequest>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
